// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/***************/
/* Main layout */
/***************/

.app-browser, .app-game-console, .app-game-editor {
    width:1249px;
    
    margin-left: auto;
    margin-right: auto;
}

.eskuel .header-meta {
    margin-top: 20px;
    margin-bottom: 20px;
}

.eskuel .header-meta > li {
    display: inline-flex;
    column-gap: 7px;
}

.eskuel .header-name {
    display: flex;
    align-items: center;
}

.eskual .header-toolbox {
    display: flex;
    column-gap: 20px;
}

.eskuel .widget {
    height: 100%;
}

.eskuel .widget .widget-header {
    font-weight: bold;
}

.eskuel .widget > .card-body {
    overflow: auto;
}

/* Status view */
.eskuel .status-view {
    margin-bottom:10px;
}

.eskuel .last-child {
    margin-bottom: 0;
}

/* Set cell padding smaller */
.eskuel .table>:not(caption)>*>* {
    padding: 0.2rem 0.4rem;
}


/***********/
/* Browser */
/***********/


/**************************/
/* Browser + Game Console */
/**************************/

.eskuel .widget-query .widget-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    row-gap: 10px;
}

.eskuel .query-editor {
    position: relative;
}

.eskuel .query-editor-resize-handlet {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 20px;
    height: 20px; 
    cursor: ns-resize; 
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
}

.eskuel .query-editor-resize-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    bottom: 0;
    right: 0;
    cursor: ns-resize;
}

.eskuel .query-editor-resize-handle::after {
    content: "";
    position: absolute;
    right: 3px;
    bottom: 3px;
    width: 5px;
    height: 5px;
    border-right: 2px solid rgba(0, 0, 0);
    border-bottom: 2px solid rgba(0, 0, 0);
}


/**********/
/* Editor */
/**********/

.eskuel .editor {
    display: grid;
    column-gap: 10px;
    row-gap: 10px;
    grid-template-columns: 3fr 2fr;
    margin-bottom:10px;
}

.eskuel .editor > div {
    min-width: 0; /* This helps in dealing with content overflow */
    max-width: 100%; /* Ensures content does not overflow the grid area */
    overflow: auto; /* Adds scrolling to any div that overflows */
}

.eskuel .editor-meta-data-right .input-group {
    height: 100%;
}

.eskuel .editor-meta-data-title input {
    font-size: 200%;
}

.eskuel .editor-meta-data-title > span, .eskuel .editor-meta-data-copyright > span {
    width:120px;
}

.eskuel .editable-scenes-container > div:first-child { /* Droppable-container */
    display: flex;
    flex-direction: column;
    row-gap: 10px;
}

.eskuel .editable-scenes-container .editable-scene-view-header p {
    margin-bottom: 0;
}

.eskuel .editor-sidebar {
    display:flex;
    flex-direction: column;
    align-content: flex-start;
    row-gap: 10px;
}

.eskuel .add-scene-button {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}


/****************/
/* Game console */
/****************/

.eskuel .game-header {
    margin-bottom: 10px;
}

.eskuel .game-meta-data-view {
    display: grid;
    column-gap: 10px;
    grid-template-columns: 5fr 7fr;
    margin-bottom:10px;
}

.eskuel .game-meta-data-left > .card-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    row-gap:20px;
}

.eskuel .game-meta-data-title input {
    font-size: 200%;
}

.eskuel .game-meta-data-sub {
    display: flex;
    justify-content: space-between;
}

/* Scene widget */
.eskuel .widget-scene .widget-body {
    display: inline-flex;
    flex-direction: column;
    justify-content: space-between;
    row-gap: 10px;

    font-size: 140%;
}

.eskuel .widget-scene button {
    margin-bottom: 5px;
    font-size: 120%;
}

.eskuel .widget-scene img {
    max-width: 100%;
    max-height: 100%;
}

/* Results widget */
.eskuel .widget-results .result-view {
    margin-bottom: 20px;
}

.eskuel .widget-results .result-view-header p {
    margin-bottom: 0;
}

.eskuel .widget-results .results-table-view {
    padding-top: 20px;
    padding-bottom: 20px;
}

.eskuel .widget-results .results-table-view table {
    margin-bottom: 0;
}

.eskuel .widget-results .result-view-explanation {
    padding-top: 20px;
    padding-bottom: 20px;
}


/**********/
/* Modals */
/**********/

.eskuel .modal-body .form-container {
    display: flex;
    flex-direction: column;
    row-gap: 20px;
}

.eskuel .modal-body .open-file-radio {
    display: inline-flex;
    align-items: center;

    /* padding-right:0; */
    border-top-width: 2px;
}

.eskuel .modal-body .open-file-radio-control {
    margin-top:10px;
}

.eskuel .modal-body .open-file-radio-icon {
    display: flex;
    column-gap: 10px;
    padding: 20px 10px 20px 30px;
}


/*****************/
/* Editor Modals */
/*****************/

.eskuel .choose-scene-type > label {
    display: block;
}

.eskuel .edit-scene-options {
    display: grid;
    grid-template-columns: min-content 1fr;
    column-gap: 5px;
    row-gap: 10px;
}

.eskuel .edit-scene-options div {
    min-width: 0;
}


/*****************/
/* Schema widget */
/*****************/

/* Schema widget */
.eskuel .widget-schema .widget-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.eskuel .widget-schema .schema-status {
    text-align: center;
    font-style: italic;
}

.eskuel .widget-schema .table-name {
    text-align: right;
    font-weight: bold;

    padding-right: 0;
}

.eskuel .widget-schema .table-cols {
    padding-left: 3px;
}

.eskuel .widget-schema .primary-key {
    text-decoration: underline;    
}

.eskuel .widget-schema .foreign-key {
    font-style: italic;    
}


/**********/
/* Schema */
/**********/

.eskuel .schema {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.eskuel .schema .table-name {
    text-align: right;
    font-weight: bold;

    padding-right: 0;
}

.eskuel .schema .table-cols {
    padding-left: 3px;
}

.eskuel .schema .primary-key {
    text-decoration: underline;    
}

.eskuel .schema .foreign-key {
    font-style: italic;    
}


/***********/
/* General */
/***********/

.eskuel .app-name {
    width: 200px;
}

.eskuel .clickable-icon {
    /* margin: -5px; */
    /* padding: 5px; */
    margin-left:7px;

    cursor: pointer;
}

.eskuel .clickable-icon.disabled {
    visibility: hidden;
}

.eskuel .clickable-icon-button {
    /* margin: -5px; */
    /* padding: 5px; */
    /* margin-left:7px; */

    cursor: pointer;
}

.eskuel .clickable-icon-button.disabled {
    visibility: hidden;
}

.eskuel .widget-io > .card-body {
    display: grid;
    column-gap: 30px;
    grid-template-columns: 30% 30%;
}

.eskuel .col-gap-default {
    column-gap: 10px;
}

.eskuel .row-gap-default {
    row-gap: 10px;
}


/**********************/
/* Open and load file */
/**********************/

/* .eskuel .load {
    margin-top:10px;
    margin-bottom:10px;
} */

.eskuel .load-source-panel-status {
    flex: 1 0 auto;

    margin-bottom: 0;
    padding-top:6px;
    padding-bottom:6px;
}


/**********************/
/* Browser and Editor */
/**********************/

.eskuel .tabbed-header {
    padding-left: 0;
    margin-bottom:10px;
    border-bottom: 1px solid #aaa;
}

/**********/
/* Colors */
/**********/


.eskuel .clickable-icon-button {
    background-color: rgba(255, 255, 255, 0.7);
    color: black;
}


.eskuel .app-browser .header-name  {
    background-color: rgb(155, 184, 205);
}
.eskuel .app-browser .header-toolbox, .eskuel .app-browser .header-home {
    background-color: rgba(155, 184, 205, 0.7);
}
.eskuel .app-browser .clickable-icon-button {
    background-color: rgba(255, 255, 255, 0.7);
    color: black;
}


.eskuel .app-game-console .header-name  {
    background-color: rgb(238, 199, 89);
}
.eskuel .app-game-console .header-toolbox, .eskuel .app-game-console .header-home {
    background-color: rgb(238, 199, 89, 0.7);
}
.eskuel .app-game-console .clickable-icon-button {
    background-color: rgba(255, 255, 255, 0.7);
    color: black;
}

.eskuel .app-game-editor .header-name  {
    background-color: rgb(177, 195, 129);
}
.eskuel .app-game-editor .header-toolbox, .eskuel .app-game-editor .header-home {
    background-color: rgb(177, 195, 129, 0.7);
}
.eskuel .app-game-editor .clickable-icon-button {
    background-color: rgba(255, 255, 255, 0.7);
    color: black;
}
`, "",{"version":3,"sources":["webpack://./src/screen.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,gBAAgB;AAChB,gBAAgB;;AAEhB;IACI,YAAY;;IAEZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,6BAA6B;AAC7B;IACI,sBAAsB;AAC1B;;;AAGA,YAAY;AACZ,YAAY;AACZ,YAAY;;;AAGZ,2BAA2B;AAC3B,2BAA2B;AAC3B,2BAA2B;;AAE3B;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,WAAW;IACX,qCAAqC;IACrC,sCAAsC;AAC1C;;;AAGA,WAAW;AACX,WAAW;AACX,WAAW;;AAEX;IACI,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,YAAY,EAAE,gDAAgD;IAC9D,eAAe,EAAE,oDAAoD;IACrE,cAAc,EAAE,6CAA6C;AACjE;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA,uDAAuD,wBAAwB;IAC3E,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;;AAGA,iBAAiB;AACjB,iBAAiB;AACjB,iBAAiB;;AAEjB;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA,iBAAiB;AACjB;IACI,oBAAoB;IACpB,sBAAsB;IACtB,8BAA8B;IAC9B,aAAa;;IAEb,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;;AAGA,WAAW;AACX,WAAW;AACX,WAAW;;AAEX;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;;IAEnB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,4BAA4B;AAChC;;;AAGA,kBAAkB;AAClB,kBAAkB;AAClB,kBAAkB;;AAElB;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;;AAGA,kBAAkB;AAClB,kBAAkB;AAClB,kBAAkB;;AAElB,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;;IAEjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;;AAGA,WAAW;AACX,WAAW;AACX,WAAW;;AAEX;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;;IAEjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;;AAGA,YAAY;AACZ,YAAY;AACZ,YAAY;;AAEZ;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;;IAEf,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;;IAErB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;;AAGA,uBAAuB;AACvB,uBAAuB;AACvB,uBAAuB;;AAEvB;;;GAGG;;AAEH;IACI,cAAc;;IAEd,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;;AAGA,uBAAuB;AACvB,uBAAuB;AACvB,uBAAuB;;AAEvB;IACI,eAAe;IACf,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA,WAAW;AACX,WAAW;AACX,WAAW;;;AAGX;IACI,0CAA0C;IAC1C,YAAY;AAChB;;;AAGA;IACI,oCAAoC;AACxC;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,0CAA0C;IAC1C,YAAY;AAChB;;;AAGA;IACI,mCAAmC;AACvC;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,0CAA0C;IAC1C,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;AACA;IACI,yCAAyC;AAC7C;AACA;IACI,0CAA0C;IAC1C,YAAY;AAChB","sourcesContent":["/***************/\r\n/* Main layout */\r\n/***************/\r\n\r\n.app-browser, .app-game-console, .app-game-editor {\r\n    width:1249px;\r\n    \r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\n.eskuel .header-meta {\r\n    margin-top: 20px;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.eskuel .header-meta > li {\r\n    display: inline-flex;\r\n    column-gap: 7px;\r\n}\r\n\r\n.eskuel .header-name {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.eskual .header-toolbox {\r\n    display: flex;\r\n    column-gap: 20px;\r\n}\r\n\r\n.eskuel .widget {\r\n    height: 100%;\r\n}\r\n\r\n.eskuel .widget .widget-header {\r\n    font-weight: bold;\r\n}\r\n\r\n.eskuel .widget > .card-body {\r\n    overflow: auto;\r\n}\r\n\r\n/* Status view */\r\n.eskuel .status-view {\r\n    margin-bottom:10px;\r\n}\r\n\r\n.eskuel .last-child {\r\n    margin-bottom: 0;\r\n}\r\n\r\n/* Set cell padding smaller */\r\n.eskuel .table>:not(caption)>*>* {\r\n    padding: 0.2rem 0.4rem;\r\n}\r\n\r\n\r\n/***********/\r\n/* Browser */\r\n/***********/\r\n\r\n\r\n/**************************/\r\n/* Browser + Game Console */\r\n/**************************/\r\n\r\n.eskuel .widget-query .widget-body {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    row-gap: 10px;\r\n}\r\n\r\n.eskuel .query-editor {\r\n    position: relative;\r\n}\r\n\r\n.eskuel .query-editor-resize-handlet {\r\n    position: absolute;\r\n    bottom: 0;\r\n    right: 0;\r\n    width: 20px;\r\n    height: 20px; \r\n    cursor: ns-resize; \r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: transparent;\r\n}\r\n\r\n.eskuel .query-editor-resize-handle {\r\n    position: absolute;\r\n    width: 20px;\r\n    height: 20px;\r\n    bottom: 0;\r\n    right: 0;\r\n    cursor: ns-resize;\r\n}\r\n\r\n.eskuel .query-editor-resize-handle::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    right: 3px;\r\n    bottom: 3px;\r\n    width: 5px;\r\n    height: 5px;\r\n    border-right: 2px solid rgba(0, 0, 0);\r\n    border-bottom: 2px solid rgba(0, 0, 0);\r\n}\r\n\r\n\r\n/**********/\r\n/* Editor */\r\n/**********/\r\n\r\n.eskuel .editor {\r\n    display: grid;\r\n    column-gap: 10px;\r\n    row-gap: 10px;\r\n    grid-template-columns: 3fr 2fr;\r\n    margin-bottom:10px;\r\n}\r\n\r\n.eskuel .editor > div {\r\n    min-width: 0; /* This helps in dealing with content overflow */\r\n    max-width: 100%; /* Ensures content does not overflow the grid area */\r\n    overflow: auto; /* Adds scrolling to any div that overflows */\r\n}\r\n\r\n.eskuel .editor-meta-data-right .input-group {\r\n    height: 100%;\r\n}\r\n\r\n.eskuel .editor-meta-data-title input {\r\n    font-size: 200%;\r\n}\r\n\r\n.eskuel .editor-meta-data-title > span, .eskuel .editor-meta-data-copyright > span {\r\n    width:120px;\r\n}\r\n\r\n.eskuel .editable-scenes-container > div:first-child { /* Droppable-container */\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 10px;\r\n}\r\n\r\n.eskuel .editable-scenes-container .editable-scene-view-header p {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.eskuel .editor-sidebar {\r\n    display:flex;\r\n    flex-direction: column;\r\n    align-content: flex-start;\r\n    row-gap: 10px;\r\n}\r\n\r\n.eskuel .add-scene-button {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-top: 20px;\r\n}\r\n\r\n\r\n/****************/\r\n/* Game console */\r\n/****************/\r\n\r\n.eskuel .game-header {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.eskuel .game-meta-data-view {\r\n    display: grid;\r\n    column-gap: 10px;\r\n    grid-template-columns: 5fr 7fr;\r\n    margin-bottom:10px;\r\n}\r\n\r\n.eskuel .game-meta-data-left > .card-body {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    row-gap:20px;\r\n}\r\n\r\n.eskuel .game-meta-data-title input {\r\n    font-size: 200%;\r\n}\r\n\r\n.eskuel .game-meta-data-sub {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n/* Scene widget */\r\n.eskuel .widget-scene .widget-body {\r\n    display: inline-flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    row-gap: 10px;\r\n\r\n    font-size: 140%;\r\n}\r\n\r\n.eskuel .widget-scene button {\r\n    margin-bottom: 5px;\r\n    font-size: 120%;\r\n}\r\n\r\n.eskuel .widget-scene img {\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n}\r\n\r\n/* Results widget */\r\n.eskuel .widget-results .result-view {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.eskuel .widget-results .result-view-header p {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.eskuel .widget-results .results-table-view {\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n}\r\n\r\n.eskuel .widget-results .results-table-view table {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.eskuel .widget-results .result-view-explanation {\r\n    padding-top: 20px;\r\n    padding-bottom: 20px;\r\n}\r\n\r\n\r\n/**********/\r\n/* Modals */\r\n/**********/\r\n\r\n.eskuel .modal-body .form-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    row-gap: 20px;\r\n}\r\n\r\n.eskuel .modal-body .open-file-radio {\r\n    display: inline-flex;\r\n    align-items: center;\r\n\r\n    /* padding-right:0; */\r\n    border-top-width: 2px;\r\n}\r\n\r\n.eskuel .modal-body .open-file-radio-control {\r\n    margin-top:10px;\r\n}\r\n\r\n.eskuel .modal-body .open-file-radio-icon {\r\n    display: flex;\r\n    column-gap: 10px;\r\n    padding: 20px 10px 20px 30px;\r\n}\r\n\r\n\r\n/*****************/\r\n/* Editor Modals */\r\n/*****************/\r\n\r\n.eskuel .choose-scene-type > label {\r\n    display: block;\r\n}\r\n\r\n.eskuel .edit-scene-options {\r\n    display: grid;\r\n    grid-template-columns: min-content 1fr;\r\n    column-gap: 5px;\r\n    row-gap: 10px;\r\n}\r\n\r\n.eskuel .edit-scene-options div {\r\n    min-width: 0;\r\n}\r\n\r\n\r\n/*****************/\r\n/* Schema widget */\r\n/*****************/\r\n\r\n/* Schema widget */\r\n.eskuel .widget-schema .widget-body {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n}\r\n\r\n.eskuel .widget-schema .schema-status {\r\n    text-align: center;\r\n    font-style: italic;\r\n}\r\n\r\n.eskuel .widget-schema .table-name {\r\n    text-align: right;\r\n    font-weight: bold;\r\n\r\n    padding-right: 0;\r\n}\r\n\r\n.eskuel .widget-schema .table-cols {\r\n    padding-left: 3px;\r\n}\r\n\r\n.eskuel .widget-schema .primary-key {\r\n    text-decoration: underline;    \r\n}\r\n\r\n.eskuel .widget-schema .foreign-key {\r\n    font-style: italic;    \r\n}\r\n\r\n\r\n/**********/\r\n/* Schema */\r\n/**********/\r\n\r\n.eskuel .schema {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n}\r\n\r\n.eskuel .schema .table-name {\r\n    text-align: right;\r\n    font-weight: bold;\r\n\r\n    padding-right: 0;\r\n}\r\n\r\n.eskuel .schema .table-cols {\r\n    padding-left: 3px;\r\n}\r\n\r\n.eskuel .schema .primary-key {\r\n    text-decoration: underline;    \r\n}\r\n\r\n.eskuel .schema .foreign-key {\r\n    font-style: italic;    \r\n}\r\n\r\n\r\n/***********/\r\n/* General */\r\n/***********/\r\n\r\n.eskuel .app-name {\r\n    width: 200px;\r\n}\r\n\r\n.eskuel .clickable-icon {\r\n    /* margin: -5px; */\r\n    /* padding: 5px; */\r\n    margin-left:7px;\r\n\r\n    cursor: pointer;\r\n}\r\n\r\n.eskuel .clickable-icon.disabled {\r\n    visibility: hidden;\r\n}\r\n\r\n.eskuel .clickable-icon-button {\r\n    /* margin: -5px; */\r\n    /* padding: 5px; */\r\n    /* margin-left:7px; */\r\n\r\n    cursor: pointer;\r\n}\r\n\r\n.eskuel .clickable-icon-button.disabled {\r\n    visibility: hidden;\r\n}\r\n\r\n.eskuel .widget-io > .card-body {\r\n    display: grid;\r\n    column-gap: 30px;\r\n    grid-template-columns: 30% 30%;\r\n}\r\n\r\n.eskuel .col-gap-default {\r\n    column-gap: 10px;\r\n}\r\n\r\n.eskuel .row-gap-default {\r\n    row-gap: 10px;\r\n}\r\n\r\n\r\n/**********************/\r\n/* Open and load file */\r\n/**********************/\r\n\r\n/* .eskuel .load {\r\n    margin-top:10px;\r\n    margin-bottom:10px;\r\n} */\r\n\r\n.eskuel .load-source-panel-status {\r\n    flex: 1 0 auto;\r\n\r\n    margin-bottom: 0;\r\n    padding-top:6px;\r\n    padding-bottom:6px;\r\n}\r\n\r\n\r\n/**********************/\r\n/* Browser and Editor */\r\n/**********************/\r\n\r\n.eskuel .tabbed-header {\r\n    padding-left: 0;\r\n    margin-bottom:10px;\r\n    border-bottom: 1px solid #aaa;\r\n}\r\n\r\n/**********/\r\n/* Colors */\r\n/**********/\r\n\r\n\r\n.eskuel .clickable-icon-button {\r\n    background-color: rgba(255, 255, 255, 0.7);\r\n    color: black;\r\n}\r\n\r\n\r\n.eskuel .app-browser .header-name  {\r\n    background-color: rgb(155, 184, 205);\r\n}\r\n.eskuel .app-browser .header-toolbox, .eskuel .app-browser .header-home {\r\n    background-color: rgba(155, 184, 205, 0.7);\r\n}\r\n.eskuel .app-browser .clickable-icon-button {\r\n    background-color: rgba(255, 255, 255, 0.7);\r\n    color: black;\r\n}\r\n\r\n\r\n.eskuel .app-game-console .header-name  {\r\n    background-color: rgb(238, 199, 89);\r\n}\r\n.eskuel .app-game-console .header-toolbox, .eskuel .app-game-console .header-home {\r\n    background-color: rgb(238, 199, 89, 0.7);\r\n}\r\n.eskuel .app-game-console .clickable-icon-button {\r\n    background-color: rgba(255, 255, 255, 0.7);\r\n    color: black;\r\n}\r\n\r\n.eskuel .app-game-editor .header-name  {\r\n    background-color: rgb(177, 195, 129);\r\n}\r\n.eskuel .app-game-editor .header-toolbox, .eskuel .app-game-editor .header-home {\r\n    background-color: rgb(177, 195, 129, 0.7);\r\n}\r\n.eskuel .app-game-editor .clickable-icon-button {\r\n    background-color: rgba(255, 255, 255, 0.7);\r\n    color: black;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
